import React from 'react';
import { Link } from 'react-router-dom';
import AIMix from '../../assets/network-installation.jpg';
import ITspt from '../../assets/technical_support_services.jpg';
import onsiteEng from '../../assets/cctvhik.webp';
import SoftDev from '../../assets/mobile-app-developers.webp';
import backImage from '../../assets/steall.jpg';

const ServiceHome = () => {

  return (
    <section className="py-16">
      {/* Hero Section */}
      <div
        className="bg-gradient-to-r from-[#023B8D] to-[#C5B358] relative py-24 bg-cover bg-center bg-no-repeat"
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-semibold text-white animate-fadeIn">
            Our Services
          </h1>
          <p className="text-lg md:text-2xl text-gray-100 mt-4 animate-fadeIn delay-2s">
            Driving digital transformation with innovative IT solutions
          </p>
        </div>
      </div>

      {/* Services Overview */}
      <div className="bg-gray-100 container mx-auto px-4 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Service Items */}
        <Link to={'/ITSupport'} className="flex">
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col h-full transition duration-500 hover:scale-105 hover:shadow-2xl">
            <img
              src={ITspt}
              alt="IT Support"
              className="w-full h-48 object-cover rounded-t-lg"
            />
            <h2 className="text-xl font-semibold text-blue-900 mt-6 flex-grow animate-slideUp">
              IT Support
            </h2>
            <p className="text-gray-600 mt-4 animate-fadeIn delay-1s flex-grow">
              Quick, expert online technical support to solve your IT issues instantly, ensuring your business operations run smoothly.
            </p>
          </div>
        </Link>
        <Link to={'/Network'} className='flex'>
          <div className="flex">
            <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col h-full transition duration-500 hover:scale-105 hover:shadow-2xl">
              <img
                src={AIMix}
                alt="AI and Machine Learning"
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <h2 className="text-xl font-semibold text-blue-900 mt-6 flex-grow animate-slideUp">
                Networking
              </h2>
              <p className="text-gray-600 mt-4 animate-fadeIn delay-1s flex-grow">
                We provide end-to-end support for your networking needs, from setup to ongoing maintenance.
              </p>
            </div>
          </div>
        </Link>
        <Link to={'/Software'} className="flex">
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col h-full transition duration-500 hover:scale-105 hover:shadow-2xl">
            <img
              src={SoftDev}
              alt="Software Development"
              className="w-full h-48 object-cover rounded-t-lg"
            />
            <h2 className="text-xl font-semibold text-blue-900 mt-6 flex-grow animate-slideUp">
              Software Development
            </h2>
            <p className="text-gray-600 mt-4 animate-fadeIn delay-1s flex-grow">
              Custom enterprise software solutions that are robust, scalable, and tailored to meet your specific business needs.
            </p>
          </div>
        </Link>
        <Link to={'/CCTV'} className="flex">
          <div className="bg-white rounded-lg shadow-lg p-8 flex flex-col h-full transition duration-500 hover:scale-105 hover:shadow-2xl">
            <img
              src={onsiteEng}
              alt="On-Site Engineers"
              className="w-full h-48 object-cover rounded-t-lg"
            />
            <h2 className="text-xl font-semibold text-blue-900 mt-6 flex-grow animate-slideUp">
              CCTV Services
            </h2>
            <p className="text-gray-600 mt-4 animate-fadeIn delay-1s flex-grow">
              We provide comprehensive services from installation to maintenance, ensuring your safety and peace of mind.
            </p>
          </div>
        </Link>
      </div>

      {/* Call to Action */}
      <div className="bg-white -mb-24 py-16 p-5">
        <div className="container mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-blue-900 mb-6 animate-bounce">
            Transform Your Business Today
          </h2>
          <p className="text-gray-700 text-lg md:text-xl mb-8 animate-fadeIn delay-1s">
            Contact us to explore how our solutions can help your business thrive in the digital age.
          </p>
          <Link to="/ContactPage">
            <button className="bg-[#C5B358] text-blue-900 py-3 px-8 rounded-full transition duration-300 hover:bg-[#c39e2a] hover:scale-110 animate-pulse">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServiceHome;
